export const shipwreckRatesData = [
  {
    date: "Nov. 15 - Mar. 5",
    season: "Storm",
    price: "$225",
  },
  {
    date: "Mar. 6 - Jun. 15",
    season: "Spring",
    price: "$275",
  },
  {
    date: "Jun. 16 - Sept. 30",
    season: "Summer",
    price: "$350",
  },
  {
    date: "Oct. 1 - Nov. 15",
    season: "Fall",
    price: "$275",
  },
  {
    date: "Dec. 19 - Jan. 2",
    season: "Holiday",
    price: "$325",
  },
]
